import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: undefined,
  },
  mutations: {
    auth(state, auth) {
      window.localStorage.auth = JSON.stringify(auth);
      state.auth = auth;
    },
    logout(state) {
      window.localStorage.removeItem("auth");
      state.auth = undefined;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store.js